import React from "react";

import { FreeTrialAlert } from "../components/MainApp/Alerts/FreeTrial";
import { Processes } from "../components/MainApp/Alerts/Processes";
import { ScriptStatusAlert } from "../components/MainApp/Alerts/ScriptStatusAlert";
import { SystemStatus } from "../components/MainApp/Alerts/SystemStatus";

export const AlertProvider = () => {
  return (
    <>
      {/*<SystemStatus />*/}
      <FreeTrialAlert />
      <ScriptStatusAlert />
      <Processes />
    </>
  );
};
